import { callBackendApi } from "../../../components/service/axios";

export const fetchUserList = async (page, size, userQuery, sorter) => {
  return await callBackendApi("get", "/bff/users", null, {
    page: page,
    size: size,
    sortField: sorter.sortField,
    sortDirection: sorter.sortDirection,
    id: userQuery.id,
    employeeId: userQuery.employeeId,
    fullName: userQuery.fullName,
    email: userQuery.email,
    jobProfile: userQuery.jobProfile,
    homeOffice: userQuery.homeOffice,
    homeCountry: userQuery.homeCountry,
    workingOffice: userQuery.workingOffice,
    workingOfficeCountry: userQuery.workingOfficeCountry,
    departmentCode: userQuery.departmentCode,
    department: userQuery.department,
    primaryOrganizationalHome: userQuery.primaryOrganizationalHome,
    status: userQuery.status,
    projects: userQuery.projects,
    accounts: userQuery.accounts,
  });
};
